"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styles_1 = require("@material-ui/core/styles");

var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));

var useStyles = styles_1.makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      '& > * + *': {
        marginLeft: theme.spacing(2)
      }
    }
  };
});

exports.default = function (props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size;
  var classes = useStyles();
  return react_1.default.createElement("div", {
    className: classes.root,
    role: "progressbar",
    "aria-label": "Loading"
  }, react_1.default.createElement(CircularProgress_1.default, {
    size: size
  }));
};